import React from 'react';
import createReactClass from 'create-react-class'
import xtend from 'xtend';
import struct from 'observ-struct';

import queryString from '../../../utils/QueryString.js';
import ObservApi from '../../../lib/observable-api.js';
import PreferenceStore from './ListingStore';
import EditorController from './EditorController';

import CategoryStore from '../../../metadata/components/DomainStore';
import KeywordStore from '../../../metadata/components/DomainStore';
import LocationStore from '../../../metadata/components/DomainStore';
import AssetStore from '../../../metadata/components/assets/Store';

import InvalidPermissions from '../../InvalidPermissions';

var PREF_ID = false;

export default function (api, socket, options) {

    PREF_ID = queryString.parse(window.location.search).id;

    var categoryApi = ObservApi(api.categories);
    var categoryStore = CategoryStore('categories', categoryApi.bus);

    var keywordApi = ObservApi(api.keywords);
    var keywordStore = KeywordStore('keywords', keywordApi.bus);

    var locationApi = ObservApi(api.locations);
    var locationStore = LocationStore('locations', locationApi.bus);

    var assetStore = AssetStore(api.assets, socket);

    var listingApi = ObservApi(api.channels);
    var preferenceStore = PreferenceStore(listingApi.bus);

    var state = window.state = struct({
        preference: preferenceStore.state,
        metadata: struct({
            assets: assetStore.state,
            categories: categoryStore.state,
            keywords: keywordStore.state,
            locations: locationStore.state
        })
    });

    function fetchMetadata () {
        categoryApi.actions.get({});
        keywordApi.actions.getKeywordsNonPage({}, (err, res) => {
            keywordStore.state.set({ data: res, isResolving: false })
        });
        locationApi.actions.get({});
        locationApi.actions.get({});
        assetStore.actions.get();
    }

    function getId () {
        let id = false;
        try {
            id = state().preference.preferenceID;
        } catch (e) {
            console.log(e);
        } finally {
            if (!id) id = PREF_ID;
            return id;
        }
    }

    var actions = {
        get: function () {
            listingApi.actions.getByID({
                preferenceID: PREF_ID
            });
            fetchMetadata();
        },
        handleSave: function (preference, cb) {
            var payload = { preference: preference };
            let id = getId();
            if (id) payload.preferenceID = id;
            var action = (!id) ? 'add' : 'edit';
            listingApi.actions[action](payload, cb);
        }
    };

    return createReactClass({
        render: function () {

            var props = {
                store: state,
                actions: actions,
                preferenceID: getId
            };

            return <EditorController {...this.props} {...props}/>;
        }
    });
};
